import colors from '../colors';

type RegularFont = 'ABNAMRO Sans Regular, Arial';
type CondensedFont = 'ABNAMRO Sans Regular, Arial';
type SemiboldFont = 'ABNAMRO Sans SemiBold, Arial';
type BoldFont = 'ABNAMRO Sans Bold, Arial';
type TextSize = { S: string; L: string };

export enum DefaultFontSize {
  SIZE = '16px',
  LINE_HEIGHT = '24px',
}

export const defaultTextSize = {
  S: DefaultFontSize.SIZE,
  L: DefaultFontSize.LINE_HEIGHT,
};

interface TextTheme {
  lineHeight?: TextSize;
  fontSize?: TextSize;
  fontWeight?: '400' | '500';
}

export interface FontsTheme {
  fontRegular: RegularFont;
  fontCondensed: CondensedFont;
  fontSemibold: SemiboldFont;
  fontBold: BoldFont;
  textColor: string;
  h1: TextTheme;
  h2: TextTheme;
  h3: TextTheme;
  h4: TextTheme;
  label: TextTheme;
  blockquote: TextTheme;
}

export const bisFontsTheme: FontsTheme = {
  fontRegular: 'ABNAMRO Sans Regular, Arial',
  fontCondensed: 'ABNAMRO Sans Regular, Arial',
  fontSemibold: 'ABNAMRO Sans SemiBold, Arial',
  fontBold: 'ABNAMRO Sans Bold, Arial',
  textColor: colors.abnBlack,
  h1: {
    lineHeight: {
      S: '48px',
      L: '60px',
    },
    fontSize: {
      S: '36px',
      L: '48px',
    },
  },
  h2: {
    lineHeight: {
      S: '30px',
      L: '36px',
    },
    fontSize: {
      S: '24px',
      L: '28px',
    },
  },
  h3: {
    lineHeight: {
      S: '22px',
      L: '30px',
    },
    fontSize: {
      S: '18px',
      L: '22px',
    },
  },
  h4: {
    lineHeight: {
      S: '24px',
      L: '24px',
    },
    fontSize: {
      S: '18px',
      L: '20px',
    },
  },
  label: {
    fontWeight: '400',
  },
  blockquote: {
    lineHeight: {
      S: '22px',
      L: '30px',
    },
    fontSize: {
      S: '18px',
      L: '22px',
    },
  },
};
